import { isAfter } from 'date-fns';
import { LeadStatus } from '../../../../models/Leads';

export function requiresRebooking({
  checkInDate,
  status,
}: {
  checkInDate: Date;
  status?: LeadStatus;
}): boolean {
  return status === LeadStatus.ARCHIVED && isAfter(checkInDate, new Date());
}
